/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import T from 'prop-types'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import { loginWithGoogle } from 'reducers/auth/reducer'
import withPromise from 'helpers/withPromise'
import messages from './translate'

class LoginWithGoogle extends Component {
  static propTypes = {
    loginWithGoogle: T.func.isRequired,
  }

  componentDidMount() {
    const script = document.createElement('script')
    script.src = 'https://apis.google.com/js/platform.js'
    script.async = true
    script.defer = true
    script.onload = this.initAuth
    document.head.appendChild(script)
  }

  initAuth = () => {
    window.gapi.load('auth2', () => {
      window.gapi.auth2
        .init({
          client_id: window._env.REACT_APP_GOOGLE_CLIENT_ID,
        })
        .then()
        .catch(error => {
          console.error(error)
        })
    })
  }

  googleLogIn = () => {
    const _authOk = googleUser =>
      withPromise(this.props.loginWithGoogle, {
        access_token: googleUser.getAuthResponse().access_token,
        provider: 'google',
      })
        .then(res => Promise.resolve(res))
        .catch(error => {
          console.error(error.errorString)
        })
    const _authErr = err => {
      console.error(`Authorize error: ${err} `)
    }

    const GoogleAuth = window.gapi.auth2.getAuthInstance()
    GoogleAuth.signIn({
      prompt: 'select_account',
      scope: 'profile email',
    }).then(_authOk, _authErr)
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <div className="login-with-google">
        <Button
          fullWidth
          href={null}
          type="button"
          size="large"
          color="default"
          variant="contained"
          className="MuiButton-google-login"
          onClick={this.googleLogIn}>
          <img
            src="/assets/images/google-icon.svg"
            className="google-login-icon"
            alt="G"
          />
          {formatMessage(messages.login_google)}
        </Button>
      </div>
    )
  }
}

const enhance = connect(null, { loginWithGoogle })

export default enhance(injectIntl(LoginWithGoogle))
